import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "report-detail" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      type: "info",
      icon: "el-icon-arrow-left",
      onClick: _ctx.routeBack
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode("h1", null, _toDisplayString(_ctx.fullReport?.report.title), 1),
    _createVNode(_component_el_container, { direction: "vertical" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _withDirectives(_createVNode("div", null, null, 512), [
            [_directive_loading, _ctx.fetchState !== _ctx.FetchStates.FETCHED]
          ])
        ]),
        (_ctx.fetchState === _ctx.FetchStates.FETCHED)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.uiComp), {
                report: _ctx.fullReport?.report,
                records: _ctx.fullReport?.records
              }, null, 8, ["report", "records"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512)), [
    [_directive_loading, _ctx.fetchState === _ctx.FetchStates.FETCHING]
  ])
}